import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { maxxApi } from './api/MaxxApi';
import { xxHomePageLayout } from './components/homelayout/HomepageLayout';
import { logoWidget } from './components/LogoComponent/LogoCard';
import { maxxWidget } from './components/MaxxComponent/MaxxInfoCard';
import { mexxiWidget } from './components/MexxiComponent/MexxiInfoCard';
import { toolkitWidget } from './components/Toolkit/ToolkitCard';
import { welcomeWidget } from './components/Welcome/WelcomeInfoCard';
import { announcementWidget } from './components/AnnouncementsComponent/AnnouncementsCard';

export const homeModuleCards = createFrontendModule({
  pluginId: 'home',
  extensions: [
       xxHomePageLayout,        
       maxxApi,       
       maxxWidget,    
       mexxiWidget,
       logoWidget,
       toolkitWidget,
       welcomeWidget,  
       announcementWidget,
  ],
});
